<template>
  <div class="file-manage-container">
    <el-card class="file-manage-card" shadow="hover" :body-style="{ padding: '20px',height:'100%'}">
      <div class="card-header">
        <el-tooltip class="search-btn" effect="dark" content="查找文件" placement="right">
          <el-button @click="showFindingDialog" icon="el-icon-search" circle></el-button>
        </el-tooltip>
        <el-popover :append-to-body="true" class="search-btn handle-btn" placement="right-start" width="410" trigger="click">
          <el-button title="图片处理" icon="el-icon-crop" slot="reference" circle></el-button>
          <el-form :model="handleForm" ref="handleForm" class="handle-form" inline>
            <el-form-item class="handle-form-item" prop="path" :rules="handleFormRules">
              <el-input prefix-icon="el-icon-picture-outline-round" class="handle-input" v-model="handleForm.path" autocomplete="off" size="mini" placeholder="请输入图片地址" clearable></el-input>
            </el-form-item>
            <el-form-item class="handle-form-item">
              <el-button type="primary" size="mini" @click="handleImage">处理</el-button>
            </el-form-item>
          </el-form>
        </el-popover>
        <el-select @change="envChangeHandle" v-model="form.env" placeholder="请选择项目环境">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="item in envList" :key="item.env" :label="item.label" :value="item.env"></el-option>
        </el-select>
        <el-select @change="handleChange" class="search" v-model="form.path" placeholder="请选择项目" clearable :style="{width:'202px'}" filterable remote :remote-method="handleInput" :loading="loading">
          <el-option v-for="item in projectList" :key="item.id" :label="item.projectName" :value="item.path">
          </el-option>
        </el-select>
        <div class="header-btn-box">
          <el-button plain type="primary" @click="showProjectDialog">
            <i class="btn-icon el-icon-circle-plus-outline"></i>
            新增
          </el-button>
          <el-button type="primary" @click="goFileUpload">
            <i class="btn-icon el-icon-upload"></i>
            上传
          </el-button>
        </div>
      </div>
      <div class="card-content">
        <h3 class="title">
          <span>我的项目</span>
          <el-switch class="only-me" v-model="onlyMe" active-text="只看自己" title="只看自己参与的项目" @change="onlyMeChange">
          </el-switch>
        </h3>
        <div v-if="projectList.length>0" class="my-project-container">
          <div v-for="item in projectList" :key="item.id" class="project-card" @click="goProjectDetail(item.path)">
            <div class="more-icon" title="项目编辑" @click.stop="showProjectEdit(item.id)"></div>
            <div class="project-card-header">
              <div class="project-card-image"></div>
            </div>
            <h6 class="project-name text-overflow-ellipsis">{{item.projectName}}</h6>
            <span class="project-time">{{formatTime(item.updateTime)}}</span>
          </div>
        </div>
        <div class="empty-content" v-else>
          <p class="empty-text">来创建自己的项目吧~</p>
        </div>
      </div>
      <div class="card-footer">
        <div class="latest-file-container">
          <div class="header-box">
            <h3 class="title">
              <span>最近文件</span>
            </h3>
            <el-input-number class="count" :controls="true" controls-position="right" :min="10" :max="50" size="mini" v-model="count" :step="5" step-strictly @change="getLatestFileList"></el-input-number>
          </div>
          <div v-if="latestFileList.length>0" class="content file-page-container">
            <div v-for="item in latestFileList" :key="item.id" class="latest-file-card">
              <img class="file-image" v-if="item.isImg" :src="item.url" slot="cover" />
              <div v-else class="file-icon" :class="`file-icon-${item.ext}`"></div>
              <div class="file-content">
                <div class="name text-overflow-ellipsis">{{item.filename}}</div>
                <div class="time text-overflow-ellipsis">{{formatTime(item.createTime||item.time)}}</div>
              </div>
              <div class="file-copy">
                <el-tooltip effect="dark" content="复制图片webp格式地址" placement="left">
                  <el-button v-if="item.isImg" type="text" v-clipboard:copy="item.url+'?imageMogr2/format/webp'" v-clipboard:success="onCopy">webp</el-button>
                </el-tooltip>
                <el-button type="text" v-clipboard:copy="item.url" v-clipboard:success="onCopy">复制</el-button>
                <el-button type="text" @click="downloadFile(item)">下载</el-button>
              </div>
            </div>
          </div>
          <div class="empty-content other-url" v-else>
            <p class="empty-text">最近无上传文件哦~</p>
          </div>
        </div>
        <div class="echart-container">
          <h3 class="title"><span>活跃Chart</span></h3>
          <div id="activity-chart"></div>
        </div>
      </div>
    </el-card>
    <!-- 对话框 -->
    <el-dialog :top="dialog.top" :title="dialog.title" :visible.sync="dialog.visible" :width="dialog.width" :before-close="destroyComponent" :close-on-press-escape="false" :fullscreen="fullScreen">
      <component @getProjectList="getProjectList" :is="dialog.component" @close="destroyComponent" :envList="envList" :row="row" :imageInfo="imageInfo" :pId="pId" :date="date" :userId="userId" />
    </el-dialog>
  </div>
</template>

<script>
import { xpsApi, fileManageApi } from '@/api/index';
import { showLoading, hideLoading } from '@/plugins/loading';
import { dialogMixin } from "@/common/mixins/";
import projectForm from "./components/projectForm.vue";
import fileFinding from "./components/fileFinding/index.vue";
import localFileDialog from "./components/fileFinding/localFileDialog.vue";
import imageHandle from "./components/imageHandle.vue";
import projectEdit from "./components/projectEdit/index.vue";
import { getExt, isImg } from '@/common/utils/ext.js';
import { downloadFile } from '@/common/utils/download.js';
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import axios from 'axios';
let validateImagePath = (rule, value, callback) => {
  if (!(/^https\:\/\/front|uat\-xps|asset|daily|qa|grey|prod\-cdn\.xsyx\.xyz\//.test(value))) {
    callback(new Error('XPS不支持处理图片地址！'));
  } else if (!isImg(value)) {
    callback(new Error('只能处理特定后缀的图片格式！'));
  } else {
    callback();
  }
}
export default {
  mixins: [dialogMixin],
  data () {
    return {
      form: {
        env: '',
        path: '',
      },
      projectList: [],
      latestFileList: [],
      envList: [],
      loading: false,
      myDaysFileCount: [],
      allDaysFileCount: [],
      count: 20,
      handleForm: {
        path: ''
      },
      handleFormRules: [
        { required: true, message: '图片地址不能为空！' },
        { validator: validateImagePath, trigger: 'blur' }
      ],
      row: null,
      imageInfo: null,
      pId: '',
      onlyMe: false,
      date: '',
      fullScreen: false,
      userId: ''
    }
  },
  mounted () {
    this.onlyMe = localStorage.getItem('XPS_PROJECT_ONLY_ME') && JSON.parse(localStorage.getItem('XPS_PROJECT_ONLY_ME'));
    this.getEnvList();
    this.getChartData();
    this.getLatestFileList();
  },
  computed: {
    projectName (val) {
      if (this.projectList.length > 0 && this.form.path) {
        return this.projectList.find(item => item.path === this.form.path).projectName;
      }
      return '';
    },
    ...mapGetters(['userInfo'])
  },
  methods: {
    // 显示项目编辑弹窗
    async showProjectEdit (id) {
      this.pId = id;
      const res = await fileManageApi.getProjectEditPower({ id })
      if (res.code === 200 && res.data) {
        this.setDialog(true, "项目编辑", projectEdit, "1200px", "8vh");
      } else {
        this.$message.error(res.message);
      }
    },
    // 图片处理
    handleImage () {
      this.$refs['handleForm'].validate(async (valid) => {
        if (valid) {
          const row = {};
          row.path = this.handleForm.path;
          row.isImg = isImg(this.handleForm.path);
          row.ext = getExt(this.handleForm.path);
          const { data } = await axios.get(`${row.path}?imageInfo`);
          data.width = data.width - 0;
          data.height = data.height - 0;
          this.imageInfo = data;
          this.row = row;
          this.setDialog(true, "图片处理", imageHandle, "1000px", "5vh");
        } else {
          return false;
        }
      });

    },
    // 显示文件查找弹窗
    showFindingDialog () {
      this.setDialog(true, "文件查找", fileFinding, "1200px", "8vh");
    },
    // 获取环境列表
    async getEnvList () {
      const res = await fileManageApi.getEnvList();
      if (res.code === 200) {
        this.envList = res.data;
      }
      this.form.env = localStorage.getItem('XPS_PROJECT_ENV') || '';
      this.getProjectList();
    },
    // 获取最近上传文件列表
    async getLatestFileList () {
      if (!this.count) {
        this.$nextTick(() => {
          this.count = 10;
        })
      }
      const count = this.count ? this.count : 10
      showLoading();
      const res = await xpsApi.getLatestFileList({ count });
      if (res) {
        res.list.forEach(item => {
          item.isImg = isImg(item.url);
          item.ext = getExt(item.url);
        })
        this.latestFileList = res.list;
      }
      hideLoading();
    },
    // 下载
    async downloadFile (file) {
      downloadFile(file.url, file.filename);
    },
    // 当选择环境触发事件
    envChangeHandle () {
      this.form.path = "";
      window.localStorage.setItem('XPS_PROJECT_ENV', this.form.env);
      this.getProjectList();
    },
    // 更改只看自己的项目状态，触发函数
    onlyMeChange (val) {
      localStorage.setItem('XPS_PROJECT_ONLY_ME', val);
      this.getProjectList()
    },
    // 复制
    onCopy () {
      this.$message.success('文件地址复制成功', 2);
    },
    // 显示新增工程对话框
    showProjectDialog () {
      this.setDialog(true, "新增项目", projectForm, "40%", "15vh");
    },
    // 格式化时间
    formatTime (time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
    },
    //返回最近七天的日期
    getday () {
      let days = [];
      let date = new Date();
      for (let i = 0; i <= 144; i += 24) {		//144是前六天的小时数
        let dateItem = new Date(date.getTime() - i * 60 * 60 * 1000);	//使用当天时间戳减去以前的时间毫秒（小时*分*秒*毫秒）
        let y = dateItem.getFullYear();	//获取年份
        let m = dateItem.getMonth() + 1;	//获取月份js月份从0开始，需要+1
        let d = dateItem.getDate();	//获取日期
        m = this.addDate0(m);	//给为单数的月份补零
        d = this.addDate0(d);	//给为单数的日期补零
        let valueItem = y + '-' + m + '-' + d;	//组合
        days.push(valueItem);	//添加至数组
      }
      return days.reverse();
    },
    //给日期加0
    addDate0 (time) {
      if (time.toString().length == 1) {
        time = '0' + time.toString();
      }
      return time;
    },
    // 获取图表数据
    async getChartData () {
      showLoading();
      const res = await xpsApi.getOneWeekFileList();
      if (res) {
        const myDaysFileCount = [];
        const allDaysFileCount = [];
        const data = res.data.myFileList;
        const data1 = res.data.allFileList;
        const myFileList = this.keysMapping(data, 'time', 'fileCount');
        const allFileList = this.keysMapping(data1, 'time', 'fileCount');;
        const days = this.getday();
        days.forEach(item => {
          myDaysFileCount.push(myFileList[item] ? myFileList[item] : 0)
        })
        days.forEach(item => {
          allDaysFileCount.push(allFileList[item] ? allFileList[item] : 0)
        });
        this.myDaysFileCount = myDaysFileCount;
        this.allDaysFileCount = allDaysFileCount;
        this.initChart();
      }
      hideLoading()
    },
    // 按日期格式化数据
    keysMapping (data = [], key, val) {
      if (!key && !val) return;
      const obj = {};
      data.forEach(item => {
        obj[item[key]] = item[val];
      })
      return obj;
    },
    // 初始化图表
    initChart () {
      const myChart = this.echarts.init(document.getElementById('activity-chart'));
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        toolbox: {
          feature: {
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar'] },
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        legend: {
          data: ['系统文件', '我的文件']
        },
        xAxis: [
          {
            type: 'category',
            data: this.getday(),
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '文件数量/个',
            // min: 0,
            // max: 300,
            // interval: 50,
            axisLabel: {
              formatter: '{value}'
            }
          }
        ],
        series: [
          {
            name: '系统文件',
            type: 'bar',
            data: this.allDaysFileCount,
            markPoint: {
              data: [
                { type: 'max', name: 'Max' },
                { type: 'min', name: 'Min' }
              ]
            },
            markLine: {
              data: [{ type: 'average', name: 'Avg' }]
            }
          },
          {
            name: '我的文件',
            type: 'bar',
            data: this.myDaysFileCount,
            markPoint: {
              data: [
                { type: 'max', name: 'Max' },
                { type: 'min', name: 'Min' }
              ]
            },
          },
        ]
      };
      myChart.on('click', (params) => {
        console.log('params', params)
        if (params.seriesType === 'bar') {
          if (params.seriesName === '我的文件') {
            this.userId = this.userInfo.id;
          } else {
            this.userId = ''
          }
          this.date = params.name;
          this.fullScreen = true;
          this.setDialog(true, params.name, localFileDialog);
        }
      })

      myChart.setOption(option);
      window.addEventListener('resize', function () {
        myChart.resize();
      })
    },
    // 跳转到工程详情页面
    goProjectDetail (path) {
      let param = {
        path
      }
      this.$store.commit('config/SET_ALL_BTN_RETURN_ROUTER', this.$route.name);
      this.$router.push({ path: '/fileManage/projectDetail', query: param });
    },
    // 跳转到文件上传页面
    goFileUpload () {
      this.$router.push({ path: '/fileUpload', query: this.form });
    },
    // 销毁动态组件
    destroyComponent () {
      this.fullScreen = false;
      this.setDialog(false, "", null, "1100px", "1vh");
    },
    // 获取项目列表
    async getProjectList (projectName) {
      showLoading();
      this.loading = true;
      let res = null;
      if (projectName) {
        res = await fileManageApi.getProjects({ env: this.form.env, projectName, onlyMe: this.onlyMe });
      } else {
        res = await fileManageApi.getProjects({ projectName: this.projectName, onlyMe: this.onlyMe, ...this.form });
      }
      if (res.code === 200) {
        this.projectList = res.data;
      } else {
        this.$message.error('服务异常！')
      }
      hideLoading();
      this.loading = false;
    },
    handleChange () {
      this.getProjectList();
    },
    handleInput (val) {
      this.form.path = '';
      this.getProjectList(val);
    },
  }
}
</script>

<style lang="scss">
.file-manage-container {
  padding: 24px;
  height: calc(100% - 20px);
  .file-manage-card {
    height: 100%;
    border-radius: 16px;
    .header-box {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      .count {
        width: 100px;
        margin-right: 20px;
      }
    }
    .title {
      margin: 0 0 0 10px;
      position: relative;
      .only-me {
        float: right;
        margin-top: 4px;
        .el-switch__label {
          font-weight: 700;
          color: #606266;
          &.is-active {
            color: #409eff;
          }
        }
      }
      > span {
        position: relative;
        z-index: 2;
      }
      &::before {
        position: absolute;
        content: "";
        width: 24px;
        height: 24px;
        background-color: #e8f2ff;
        border-radius: 50%;
        left: -12px;
      }
    }
  }
  .empty-content {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    width: 100%;
    height: 220px;
    background-image: url("https://front-xps-cdn.xsyx.xyz/2021/10/22/1737927985.png");
    background-repeat: no-repeat;
    background-size: auto 100%;
    background-position: center;
    .empty-text {
      font-weight: 500;
      color: #bcbcbc;
    }
  }
  .empty-content.other-url {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-image: url("https://front-xps-cdn.xsyx.xyz/2021/10/22/973595372.png");
  }
  .card-header {
    position: relative;
    display: flex;
    margin: 0 0 10px 10px;
    justify-content: flex-end;
    .search-btn {
      position: absolute;
      left: 0;
      &.handle-btn {
        left: 40px;
      }
    }
    .header-btn-box {
      .btn-icon {
        margin-right: 4px;
      }
    }
    .search {
      margin: 0 15px;
      width: 240px;
      max-width: 30%;
    }
  }
  .my-project-container {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    overflow-x: auto;
    .project-card {
      position: relative;
      flex: 1;
      margin: 10px;
      padding: 20px;
      max-width: 25%;
      min-width: 250px;
      height: 200px;
      background-color: #f7f6f9;
      border-radius: 10px;
      transition: 0.3s;
      cursor: pointer;
      &-header {
        display: flex;
        justify-content: space-between;
        align-content: center;
        align-items: center;
        width: 100%;
      }
      &-image {
        padding: 10px;
        width: 60px;
        height: 60px;
        background-image: url("https://front-xps-cdn.xsyx.xyz/2021/10/14/540619191.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center;
      }
      .more-icon {
        position: absolute;
        top: 20px;
        right: 0px;
        width: 50px;
        height: 50px;
        background-image: url("https://front-xps-cdn.xsyx.xyz/2021/10/14/601594468.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center;
      }
      .project-name {
        margin: 30px 0 15px 0;
        font-size: 24px;
        color: #041677;
      }
      .project-time {
        font-size: 16px;
        font-weight: 500;
        color: #adb4bf;
      }
      &:hover {
        box-shadow: 0px 5px 10px #ccc;
      }
    }
  }
  .card-footer {
    display: flex;
    flex-flow: row nowrap;
    margin-top: 10px;
    height: calc(100% - 320px);
    .latest-file-container {
      position: relative;
      width: 50%;
      .content {
        height: calc(100% - 28px);
        overflow-y: auto;
        &::-webkit-scrollbar {
          display: none;
        }
      }
      .latest-file-card {
        display: flex;
        margin: 10px;
        justify-content: space-between;
        align-items: center;
        .file-icon {
          margin-right: 15px;
          width: 40px;
          height: 40px;
          border-radius: 8px;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center;
        }
        .file-image {
          margin-right: 15px;
          width: 40px;
          height: 40px;
          border-radius: 8px;
        }
        .file-content {
          flex: 3;
          color: #041677;
          .name {
            font-weight: 600;
          }
          .time {
            margin-top: 2px;
            font-size: 10px;
            color: #adb4bf;
          }
        }
        .file-copy {
          display: flex;
          flex-flow: row nowrap;
          justify-content: flex-end;
          margin-right: 10px;
          text-align: right;
          flex: 1;
        }
      }
    }
    .echart-container {
      width: 50%;
      height: 100%;
      #activity-chart {
        width: 100%;
        height: calc(100% - 3px);
      }
    }
  }
}
</style>